import React, { Component } from 'react';
import Inherit from '../../../core/inherit';
import withNavigate from '../../../core/withNavigate';
import PromotorAnalyticsController from './analytics.controller';

import { Trophy, UserX } from 'lucide-react';
import { Layout, SectionCard } from '../../common';
import { AnalyticsHeader, TopPromotorsTable, InactivePromotorsTable, AnalyticsStats } from './elements';
import { t } from '../../../company/labels';

class PromotorAnalytics extends Inherit(PromotorAnalyticsController, Component) {
    state = {
        loading: true,
        period: 'week',
        limit: 999, // Default to show all promotors
        channel: 'all', // Channel filter
        tagId: 'all', // Tag filter
        startDate: null, // Custom date range
        endDate: null,
        tags: [], // Available tags
        topPromotors: [],
        inactivePromotors: [],
        totalPromotors: 0,
        activePromotors: 0,
        inactiveCount: 0
    };

    render() {
        const {
            loading,
            period,
            limit,
            channel,
            tagId,
            startDate,
            endDate,
            tags,
            topPromotors,
            inactivePromotors,
            totalPromotors,
            activePromotors,
            inactiveCount
        } = this.state;

        return (
            <Layout current="promoters">
                {this.props.contextHolder}
                <div className="flex flex-col gap-4">
                    <AnalyticsHeader
                        period={period}
                        limit={limit}
                        channel={channel}
                        tagId={tagId}
                        startDate={startDate}
                        endDate={endDate}
                        tags={tags}
                        changePeriod={this.changePeriod.bind(this)}
                        changeLimit={this.changeLimit.bind(this)}
                        changeChannel={this.changeChannel.bind(this)}
                        changeTag={this.changeTag.bind(this)}
                        changeDateRange={this.changeDateRange.bind(this)}
                        goBack={this.goBackToPromotors.bind(this)}
                        loading={loading}
                    />

                    <AnalyticsStats
                        totalPromotors={totalPromotors}
                        activePromotors={activePromotors}
                        inactiveCount={inactiveCount}
                        period={period}
                        loading={loading}
                    />

                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                        <SectionCard
                            icon={<Trophy />}
                            flush
                            bodyClassName="[&_.ant-pagination]:px-5"
                            title={`${limit >= 999 ? 'Todos los' : `Top ${limit}`} ${t('promotores')}${
                                channel !== 'all' ? ` (${channel === 'moderno' ? 'Moderno' : 'Tradicional'})` : ''
                            } - ${period === 'day' ? 'Hoy' : period === 'week' ? 'Esta Semana' : 'Este Mes'}`}>
                            <TopPromotorsTable promotors={topPromotors} loading={loading} navigateToPromoter={this.navigateToPromoter.bind(this)} />
                        </SectionCard>

                        <SectionCard title={`${t('promotores')} Sin Actividad`} icon={<UserX />} flush bodyClassName="[&_.ant-pagination]:px-5">
                            <InactivePromotorsTable
                                promotors={inactivePromotors}
                                loading={loading}
                                period={period}
                                navigateToPromoter={this.navigateToPromoter.bind(this)}
                            />
                        </SectionCard>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default withNavigate(PromotorAnalytics);
